import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { NavifyService } from '../services/navify.service';


@Injectable({
  providedIn: 'root'
})
export class AuthguardService {
  constructor(private readonly navifyService: NavifyService,
    private readonly router: Router
  ) { }

  async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Promise<boolean> {
    let shouldLogOut = false;
    try {
      const isLoggedIn = await this.navifyService.isLoggedIn();
      if (isLoggedIn) {
        return true;
      }
      shouldLogOut = true;
    } catch {
      // Fail closed and route to login on unexpected auth check errors.
    }
    if (shouldLogOut) {
      await this.navifyService.logOut();
    }
    this.router.navigate(['login'], { queryParams: { returnUrl: this.router.url } });
    return false;
  }
}

export const AuthGuard: CanActivateFn = (route, state) => {
  return inject(AuthguardService).canActivate(route, state);
};
